Hop.defineModule('brief-entrust-my-research-tooltip', async (root) => {
    let updateWebPrefs;
    let shouldMarkAsDisplayed = true;
    let isLateralNavbar;
    const productTour = root.querySelector('#malt-plus-wizard') || root;

    const overriddenModalIds = ['slideShowModal', 'welcomeModal'];

    function markAsDisplayed() {
        fetch('/api/webpref/brief-entrust-my-research-mark-as-displayed', {
            headers: new Headers(),
            method: 'POST',
        });
    }

    async function init() {
        isLateralNavbar = productTour.attributes['target'].value !== '#main-header-deposit-brief';
        if (isLateralNavbar) {
            // Wait for the navbar MF to be fully loaded
            window.addEventListener('aside-menu-loaded', displayTour);
        } else {
            await displayTour();
        }
    }

    async function elementReady(selector) {
        return new Promise((resolve) => {
            const el = document.querySelector(selector);
            if (el) {
                resolve(el);
                return;
            }
            new MutationObserver((mutationRecords, observer) => {
                // Query for elements matching the specified selector
                Array.from(document.querySelectorAll(selector)).forEach((element) => {
                    resolve(element);
                    observer.disconnect();
                });
            }).observe(document.documentElement, {
                childList: true,
                subtree: true,
            });
        });
    }

    async function displayTour() {
        const dontDisplayModal = overriddenModalIds.some((modalId) => document.getElementById(modalId));

        /**
         *  Scenario: login after signup sometimes display modals (welcome slideshow, onboarding...)
         *  In these cases, we don't want to stack overlays elements.
         *  So the priorities are : the modals. Not the product tour.
         */
        if (dontDisplayModal) {
            shouldMarkAsDisplayed = false;
            return;
        }

        const targetElement = productTour.attributes['target'].value || '#main-header-deposit-brief';
        await elementReady(targetElement);

        const targetToHighlight = document.querySelector(targetElement);
        if (productTour && targetToHighlight) {
            await customElements.whenDefined('joy-product-tour');
            await productTour.componentOnReady();
            await productTour.showProductTour(targetToHighlight);

            updateWebPrefs = setTimeout(() => {
                markAsDisplayed();
            }, 5000);
        } else {
            shouldMarkAsDisplayed = false;
            console.error('Unable to init product tour', productTour, targetToHighlight);
        }
    }

    await init();

    return function destroy() {
        if (updateWebPrefs) {
            clearTimeout(updateWebPrefs);
        }
        if (shouldMarkAsDisplayed) {
            markAsDisplayed();
        }
        if (isLateralNavbar) {
            window.removeEventListener('aside-menu-loaded', displayTour);
        }
    };
});
